import { fork } from 'redux-saga/effects';

import PhoneSaga from 'pages/Phone/saga';
import BirthdaySaga from 'pages/Birthday/saga';
import GenderSaga from 'pages/Gender/saga';
import WorkingSaga from 'pages/Working/saga';
import ExperienceSaga from 'pages/Experience/saga';
import MounthlySaga from 'pages/Mounthly/saga';
import ConfirmationSaga from 'pages/Confirmation/saga';
import NameSaga from 'pages/Name/saga';
import UploadSaga from 'pages/Upload/saga';
import SearchSaga from 'pages/Search/saga';
import ApprovedSaga from 'pages/Approved/saga';
import CarPageSaga from 'pages/CarPage/saga';
import DeliveryPageSaga from 'pages/Delivery/saga';
import SignatureSaga from 'pages/Signature/saga';
import PaymentSaga from 'pages/Payment/saga';
import EmailSaga from 'pages/Email/saga';
import ProfileCarsSaga from 'pages/ProfileCars/saga';
import LoginSaga from 'pages/Login/saga';
import LoginAdminSaga from 'pages/LoginAdmin/saga';
import CarEditorSaga from 'pages/CarEditorPage/saga';
import AdminRestorePassSaga from 'pages/AdminRestorePass/saga';


export default function* mainSaga() {
  yield fork(PhoneSaga);
  yield fork(BirthdaySaga);
  yield fork(GenderSaga);
  yield fork(WorkingSaga);
  yield fork(ExperienceSaga);
  yield fork(MounthlySaga);
  yield fork(ConfirmationSaga);
  yield fork(NameSaga);
  yield fork(UploadSaga);
  yield fork(SearchSaga);
  yield fork(ApprovedSaga);
  yield fork(CarPageSaga);
  yield fork(DeliveryPageSaga);
  yield fork(SignatureSaga);
  yield fork(PaymentSaga);
  yield fork(EmailSaga);
  yield fork(ProfileCarsSaga);
  yield fork(LoginSaga);
  yield fork(LoginAdminSaga);
  yield fork(CarEditorSaga);
  yield fork(AdminRestorePassSaga);
}



// WEBPACK FOOTER //
// ./src/store/saga.js